import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetPosts } from "../../../hooks/blog/posts/useGetPosts";
import { useDeletePost } from "../../../hooks/blog/posts/useDeletePost";
import useTableActions from "../../../hooks/common/useTableActions";

import TableLayout from "../../global/Table/TableLayout";
import { PostsTableColumns } from "./Table/PostsTableColumns";
import PostsTableRow from "./Table/PostsTableRow";

const PostsTable = () => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");

    const { deletePostMutate, isDeleting } = useDeletePost();

    const {
        page,
        perPage,
        search,
        order,
        selectedIds,
        menuAnchorEl,
        setSearch,
        handleRequestSort,
        handleRowCheckboxClick,
        handleSelectAllClick,
        handleMenuOpen,
        handleMenuClose,
        handleEdit,
        handleMenuDelete,
        handleBulkDelete,
        handlePageChange,
        handlePerPageChange,
    } = useTableActions({
        basePath: "/blog/posts",
        deleteSingle: deletePostMutate,
    });

    const params = useMemo(() => {
        return {
            page,
            per_page: perPage,
            search: search || undefined,
            sort_by: "created_at",
            sort_order: order,
        };
    }, [page, perPage, search, order]);

    const { posts, meta, isLoading, error } = useGetPosts(params);

    const renderRow = (rowProps) => (
        <PostsTableRow
            {...rowProps}
            item={rowProps.item}
            isSelected={selectedIds.includes(rowProps.item.id)}
            onRowCheckboxClick={handleRowCheckboxClick}
            onMenuOpen={handleMenuOpen}
        />
    );

    const title = isArabic ? "مقالات المدونة" : "Blog Posts";
    const subtitle = isArabic ? "إدارة مقالات المدونة" : "Manage blog posts and articles";

    return (
        <TableLayout
            title={title}
            subtitle={subtitle}
            search={search}
            onSearchChange={setSearch}
            addButtonLabel={isArabic ? "إضافة مقال" : "Add Post"}
            onAddClick={() => navigate("/blog/posts/create")}
            isLoading={isLoading}
            error={error}
            items={posts}
            meta={meta}
            page={page}
            perPage={perPage}
            onPageChange={handlePageChange}
            onPerPageChange={handlePerPageChange}
            order={order}
            onRequestSort={handleRequestSort}
            selectedIds={selectedIds}
            onSelectAllClick={(e) => handleSelectAllClick(e, posts)}
            onRowCheckboxClick={handleRowCheckboxClick}
            onBulkDelete={handleBulkDelete}
            columns={PostsTableColumns}
            renderRow={renderRow}
            menuAnchorEl={menuAnchorEl}
            openMenu={Boolean(menuAnchorEl)}
            onMenuOpen={handleMenuOpen}
            onMenuClose={handleMenuClose}
            onMenuEdit={handleEdit}
            onMenuDelete={handleMenuDelete}
            isDeletingSingle={isDeleting}
            emptyLabelAr="لا توجد مقالات حالياً"
            emptyLabelEn="No posts found"
        />
    );
};

export default PostsTable;
